import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { FaTimes, FaTrash } from 'react-icons/fa';
import './CarritoSidebar.css';

const CarritoSidebar = ({ isOpen, onClose }) => {
  const { cart, dispatch } = useCart();
  const navigate = useNavigate();

  // Función para calcular el total sumando (precio * cantidad) de cada ítem
  const totalCarrito = cart.reduce((total, item) => {
    return total + (item.precio_unitario * item.cantidad);
  }, 0);

  const formatearPrecio = (precio) => {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(precio);
  };

  const handleIrAlCheckout = () => {
    onClose(); // Cerramos el sidebar
    navigate('/checkout'); // Redirigimos a la pantalla de pago
  };

  return (
    <>
      {/* Fondo oscuro transparente que cubre la pantalla cuando el carrito está abierto */}
      <div 
        className={`carrito-overlay ${isOpen ? 'open' : ''}`} 
        onClick={onClose}
      ></div>

      {/* El panel lateral en sí */}
      <div className={`carrito-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="carrito-header">
          <h2>Tu Pedido</h2>
          <button className="btn-cerrar-carrito" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="carrito-body">
          {cart.length === 0 ? (
            <div className="carrito-vacio">
              <p>Tu carrito está vacío.</p>
              <button className="btn-seguir-comprando" onClick={onClose}>
                Ver catálogo
              </button>
            </div>
          ) : (
            <ul className="carrito-lista">
              {cart.map((item, index) => {
                const subtotal = item.precio_unitario * item.cantidad;
                
                return (
                  <li key={index} className="carrito-item">
                    <img src={item.imagen_url || '/placeholder-queso.jpg'} alt={item.nombre} className="carrito-item-img" />
                    
                    <div className="carrito-item-info">
                      {/* Fila 1: Nombre y botón de eliminar */}
                      <div className="carrito-item-header">
                        <h4>{item.nombre}</h4>
                        <button 
                          className="btn-eliminar-item" 
                          onClick={() => dispatch({ type: 'REMOVE_FROM_CART', payload: index })}
                        >
                          <FaTrash />
                        </button>
                      </div>
                      
                      {/* Fila 2: Presentación y Maduración */}
                      <p className="carrito-item-variante">
                        {item.formato} - {item.maduracion === 0 ? 'Fresco' : `${item.maduracion} días`}
                      </p>
                      
                      {/* Fila 3: Controles (-) (+) a la izq, Subtotal a la der */}
                      <div className="carrito-item-controles-subtotal">
                        <div className="carrito-contador">
                          <button 
                            onClick={() => dispatch({ 
                              type: 'UPDATE_QUANTITY', 
                              payload: { index, newQuantity: item.cantidad - 1 } 
                            })}
                            disabled={item.cantidad <= 1}
                          >
                            -
                          </button>
                          
                          <span>{item.cantidad}</span>
                          
                          <button 
                            onClick={() => dispatch({ 
                              type: 'UPDATE_QUANTITY', 
                              payload: { index, newQuantity: item.cantidad + 1 } 
                            })}
                            // Usamos el stock_maximo que guardamos desde el DetalleProducto
                            disabled={item.cantidad >= (item.stock_maximo || 99)}
                          >
                            +
                          </button>
                        </div>
                        
                        <div className="carrito-subtotal">
                          {formatearPrecio(subtotal)}
                        </div>
                      </div>

                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        {cart.length > 0 && (
          <div className="carrito-footer">
            <div className="carrito-total">
              <span>Total:</span>
              <span>{formatearPrecio(totalCarrito)}</span>
            </div>
            <button className="btn-iniciar-compra" onClick={handleIrAlCheckout}>
              Iniciar Compra
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CarritoSidebar;